export default __webpack_public_path__ + "eb7a9ba311a26e14f775ea61bb749253.svg";